// extracted by mini-css-extract-plugin
export default {"root":"AutocompleteForm_root__CfbYT"};